import { FC } from "react";
import { Step } from "./OrgHrisConfigContext";
import AutoLayout from "@src/deprecatedDesignSystem/components/AutoLayout";
import Text from "@ui/text";
import { deprecatedTones } from "@src/deprecatedDesignSystem/styles/deprecatedColors";
import Banner from "@src/deprecatedDesignSystem/components/Banner";

type Props = {
  step: Step;
  inHrisCsvSetup?: boolean;
};

const STEP_TO_TITLE_COPY: { [key in Step]: string } = {
  connect: "Let's Connect",
  verify: "Everything look right?",
  activate: "Let's Go",
};

const getStepLabel = (step: Step, inHrisCsvSetup: boolean) => {
  if (inHrisCsvSetup && step === "activate") {
    return "APPLY";
  } else {
    return step.toUpperCase();
  }
};

const getStepDescription = (step: Step, inHrisCsvSetup: boolean) => {
  if (step === "connect") {
    return "Integrate your HRIS to get started. If each location has it’s own HRIS, make sure to connect all of them.";
  } else if (step === "verify") {
    return (
      <Banner
        type={"blue"}
        icon="speech-bubble"
        width="full"
        text="Reach out to Customer Support via chat if you'd like to make a change"
      />
    );
  } else if (step === "activate" && inHrisCsvSetup) {
    return "We’re all set up. Once you press apply we will:";
  } else if (step === "activate") {
    return "We’re all set up. Once you press activate we will:";
  }
};

export const StepHeader: FC<Props> = ({ step, inHrisCsvSetup = false }) => {
  const label = getStepLabel(step, inHrisCsvSetup);
  const title = STEP_TO_TITLE_COPY[step];
  const description = getStepDescription(step, inHrisCsvSetup);

  return (
    <AutoLayout direction="vertical">
      <Text
        type="P4"
        fontWeight="Medium"
        color={deprecatedTones.gray8}
        marginBottom={20}
      >
        {label}
      </Text>
      <Text type="title" fontWeight="Medium" marginBottom={12}>
        {title}
      </Text>
      {description && typeof description === "string" && (
        <Text
          type="P1"
          multiline
          fontWeight="Regular"
          color={deprecatedTones.gray11}
        >
          {description}
        </Text>
      )}
      {description && typeof description !== "string" && description}
    </AutoLayout>
  );
};
